import type { CameraPose, CenterMode } from "@workspace/blocks";

export const SPLAT_METADATA_DELIMITER = "---gsplat-metadata---";

export type SplatViewerMetadata = {
	camera?: CameraPose;
	centerMode?: CenterMode;
	collision?: { jsonUrl: string; binUrl: string };
	lod?: {
		manifestUrl: string;
		sourceUrl: string;
		sourceBytes: number;
		bytes: number;
		levels: number;
		distances?: number[];
		levelRatios?: number[];
	};
};

export function encodeDescriptionWithMetadata(description: string, metadata: SplatViewerMetadata | null): string {
	if (!metadata?.camera && !metadata?.centerMode && !metadata?.collision && !metadata?.lod) {
		return description;
	}
	return `${description}\n\n${SPLAT_METADATA_DELIMITER}\n${JSON.stringify(metadata)}`;
}

export function parseDescriptionWithMetadata(description: string | null | undefined): {
	displayDescription: string;
	metadata: SplatViewerMetadata | null;
} {
	if (!description?.includes(SPLAT_METADATA_DELIMITER)) {
		return { displayDescription: description?.trim() ?? "", metadata: null };
	}

	const parts = description.split(SPLAT_METADATA_DELIMITER);
	const displayDescription = parts[0].trim();
	try {
		const parsed = JSON.parse(parts[1].trim()) as SplatViewerMetadata;
		return { displayDescription, metadata: parsed };
	} catch {
		return { displayDescription: description.trim(), metadata: null };
	}
}

export function buildUploadMetadata(
	camera: CameraPose | null | undefined,
	centerMode: CenterMode,
): SplatViewerMetadata | null {
	if (!camera && centerMode === "robust") {
		return null;
	}
	return {
		...(camera ? { camera } : {}),
		...(centerMode !== "robust" ? { centerMode } : {}),
	};
}
